import { defineStore } from "pinia";
import { useSystemStore } from "./system";
import { FILE_EXCEL, GET_GRID, GET_GRID_DETAIL, GET_PANEL } from "./lib/apis";

export const useDashboardStore = defineStore("dashboard", {
  state: () => ({
    activePanel: "",
    autoplay: false,
    fixed: false,
    panelData: {},
    panelStack: [],
    sliders: [],
    toolbar: {},
  }),

  actions: {
    addPanelToStack(panelStackData) {
      this.panelStack.push(panelStackData);
    },
    clearDashboard() {
      this.activePanel = "";
      this.panelData = {};
      this.sliders = [];
    },
    downloadExcelFile(params) {
      return new Promise((resolve, reject) => {
        // importa a store do sistema
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post({
            url: FILE_EXCEL,
            data: { ...params },
            responseType: "arraybuffer",
          })
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    loadGrid(params) {
      return new Promise((resolve, reject) => {
        // importa a store do sistema
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post({ url: GET_GRID, data: { ...params }, responseType: "text" })
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    loadGridDetails(params) {
      return new Promise((resolve, reject) => {
        // importa a store do sistema
        const systemStore = useSystemStore();
        // faz a chamada
        systemStore
          .post({
            url: GET_GRID_DETAIL,
            data: { ...params },
            responseType: "text",
          })
          // caso a chamada seja bem sucedida
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    loadPanel(params) {
      return new Promise((resolve, reject) => {
        // importa a store do sistema
        const systemStore = useSystemStore();
        // retorna erro caso não receba path
        if (typeof params.path === "undefined") {
          reject({
            sysMsg: "missing-params",
            params: "store/dashboard/actions.js -> loadPanel()",
          });
          return;
        }
        // faz a chamada
        systemStore
          .post({ url: GET_PANEL, data: params.path, responseType: "text" })
          // caso a chamada seja bem sucedida
          .then((resp) => {
            let data = resp?.data;

            // Seta custom field como objeto caso esteje como String
            if (typeof data.custom == "string") {
              try {
                data.custom = JSON.parse(data.custom);
              } catch (e) {
                reject(e);
                return;
              }
            }

            if (data) {
              // adiciona o painel de retorno, caso seja passada a posição nos parâmetros
              if (params.action !== "back") {
                this.addPanelToStack({
                  panelTitle: data?.painelTitle,
                  panelPath: params?.path,
                  panelBack: data?.back,
                  previousPosition: params?.position ?? 0,
                  loadPanelFunction: params?.loadPanelFunction,
                });
              } else {
              }
            }

            resolve(data);
          })
          //
          .catch((e) => {
            reject(e);
          });
      });
    },
    setAutoplay(payload) {
      if (typeof payload != "boolean") return;
      this.autoplay = payload;
    },
    setToolbar(payload) {
      if (typeof payload != "object") return;
      this.toolbar = payload;
    },
  },
});
